import React from 'react';
import EditFieldModal from '../Edit items/EditFieldModal';
import EditPhoneNumber from '../Edit items/EditPhoneNumber';
import { Card, CardHeader, CopyButton, Empty, Row } from './primitives';

/*
 * Who to contact. Phone is the single most-copied value on this screen, so it
 * gets a copy affordance rather than making people select it by hand.
 *
 * The edit controls are still the existing Bootstrap modals — replacing those
 * with a Radix dialog is scoped as separate work, since it touches four forms
 * that currently work.
 */
const CustomerCard = ({ order, orderId, isEditable, onSaved }) => {
  const phone = order.contact_number
    ? `${order.country_code ? `${order.country_code} ` : ''}${order.contact_number}`
    : null;

  return (
    <Card>
      <CardHeader title="Customer" />
      <div className="px-3.5 py-2.5">
        <Row
          label="Name"
          action={
            isEditable && (
              <EditFieldModal
                fieldKey="contact_name"
                fieldLabel="Customer name"
                fieldValue={order.contact_name}
                id={orderId}
                modalId="editcontact_nameModal"
                title="Edit customer name"
                placeholder="Enter customer name"
                onSaved={onSaved}
              />
            )
          }
        >
          {order.contact_name || <Empty />}
        </Row>
        <Row
          label="Phone"
          action={
            <>
              <CopyButton value={phone} label="Copy phone number" />
              {isEditable && (
                <EditPhoneNumber
                  id={orderId}
                  order={order}
                  onSaved={onSaved}
                />
              )}
            </>
          }
        >
          {phone ? (
            <span className="tabular-nums">{phone}</span>
          ) : (
            <Empty />
          )}
        </Row>
      </div>
    </Card>
  );
};

export default CustomerCard;
